import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

// https://dev.to/apertureless/lets-build-a-web-app-with-vue-chartjs-and-an-api
export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        }
    },
    data () {
        return {
            options: {
                tooltips: {
                    mode: "index",
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return data.datasets[tooltipItem.datasetIndex].label + " " + numeral(tooltipItem.yLabel).format("0,0.0") + "h"
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            fontColor: "#00274F",
                            callback: function (value, index, values) {
                                return numeral(value).format("0,0.0") + "h"
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            autoSkip: true,
                            maxRotation: 0,
                            minRotation: 0,
                            fontColor: "#00274F"
                        },
                        gridLines: {
                            display: false
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: true,
                    labels: {
                        fontColor: "#00274F",
                        filter: (legendItem, chartData) => {
                            return legendItem.text && !legendItem.text.match(/\soff$/)
                        }
                    },
                    onClick: function (event, legendItem) {
                        var ci = this.chart;

                        [legendItem.datasetIndex, legendItem.datasetIndex - 1].forEach(index => {
                            var meta = ci.getDatasetMeta(index)
                            meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null
                        })

                        ci.update()
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
